<div class="sub-lob-decom">
    <div class="row-new mt-5">
        <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
            <p class="headers-style">Sub LOB</p>
            <p class="pt-2"> {{ subLobName }} </p>
        </div>
        <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
            <p class="headers-style">Decom LOB</p>
            <ng-container>
                <mat-form-field appearance="outline" class="custom-dropdown">
                    <mat-select placeholder='Decom LOB Name' [(ngModel)]="decomLobName" (selectionChange)="onSelectionChange($event)">
                        <input class="mat-input-search" type="text" (keydown)="$event.stopPropagation()" [(ngModel)]="searchTxt" matinput placeholder="Search"/>
                        <mat-option class="dropDownList" *ngFor="let item of dropdownValues | search : searchTxt" [value]="item.name">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>
        </div>
    </div>
    <div class="pull-right apply-decom-lob">
        <button mat-mdc-raised-button [disabled]="disableEditDecomLob" (click)="updateDecomLob()" class="add-apply lob-edit-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
            Apply
        </button>
    </div>
</div>
